import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Cart.css';

const Cart = () => {
  const { cartItems, removeFromCart, updateQuantity, getTotalPrice, getTotalVAT, clearCart } = useCart();

  // Prevent arrow keys from changing number input values
  const preventArrowKeyChange = (e) => {
    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
    }
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-container">
        <section className="cart-hero">
          <div className="container">
            <h1>Shopping Cart</h1>
          </div>
        </section>
        <section className="section">
          <div className="container">
            <div className="empty-cart">
              <p>Your cart is empty</p>
              <Link to="/products" className="btn btn-primary">
                Continue Shopping
              </Link>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="cart-container">
      <section className="cart-hero">
        <div className="container">
          <h1>Shopping Cart</h1>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cart-content">
            <div className="cart-items">
              <h2>Items in Cart ({cartItems.length})</h2>
              <div className="items-list">
                {cartItems.map((item) => (
                  <div key={item.id} className="cart-item">
                    {item.image_url && (
                      <div className="cart-item-image">
                        <img src={item.image_url} alt={item.name} />
                      </div>
                    )}
                    <div className="cart-item-details">
                      <h3>{item.name}</h3>
                      <p className="cart-item-price">kr {item.price}</p>
                      {item.weight && item.weight > 0 && (
                        <p className="cart-item-weight" style={{ fontSize: '0.85em', color: '#666' }}>📦 {item.weight}g</p>
                      )}
                    </div>
                    <div className="cart-item-quantity">
                      <label htmlFor={`qty-${item.id}`}>Quantity:</label>
                      <div className="quantity-input">
                        <button
                          onClick={() =>
                            updateQuantity(item.id, Math.max(1, item.quantity - 1))
                          }
                        >
                          -
                        </button>
                        <input
                          id={`qty-${item.id}`}
                          type="number"
                          min="1"
                          value={item.quantity}
                          onChange={(e) =>
                            updateQuantity(item.id, parseInt(e.target.value) || 1)
                          }
                          onKeyDown={preventArrowKeyChange}
                        />
                        <button
                          onClick={() => updateQuantity(item.id, item.quantity + 1)}
                        >
                          +
                        </button>
                      </div>
                    </div>
                    <div className="cart-item-subtotal">
                      <p>Subtotal: kr {(item.price * item.quantity).toFixed(2)}</p>
                    </div>
                    <button
                      onClick={() => removeFromCart(item.id)}
                      className="btn-remove"
                    >
                      Remove
                    </button>
                  </div>
                ))}
              </div>
            </div>

            <aside className="cart-summary">
              <h2>Order Summary</h2>
              <div className="summary-content">
                <div className="summary-row">
                  <span>Subtotal:</span>
                  <span>kr {getTotalPrice().toFixed(2)}</span>
                </div>
                <p className="tax-notice">
                  (including kr {getTotalVAT().toFixed(2)} in taxes)
                </p>
                <p className="shipping-notice">
                  *Shipping charges will be applied according to the <Link to="/shipping-policy">Shipping Policy</Link> once the order is confirmed. It will be communication over email with order confirmation.
                </p>
                <div className="summary-row total">
                  <span>Total:</span>
                  <span>kr {getTotalPrice().toFixed(2)}</span>
                </div>
                <button className="btn btn-primary" style={{ width: '100%' }}>
                  <Link to="/checkout" style={{ color: 'inherit', textDecoration: 'none', display: 'block' }}>
                    Proceed to Checkout
                  </Link>
                </button>
                <Link
                  to="/products"
                  className="btn btn-secondary"
                  style={{ width: '100%', textAlign: 'center' }}
                >
                  Continue Shopping
                </Link>
                <button
                  onClick={clearCart}
                  className="btn-clear-cart"
                >
                  Clear Cart
                </button>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cart;
